import { useCallback } from 'react';
import { useNavigate } from 'react-router';
import type { UserScreenNode } from '@/shared/types/system';
import { useTabsStore } from './tabsStore';

/** Ekranı sekmede açar (varsa odaklar) ve URL'yi /s/:screenId ile senkronlar. */
export function useOpenScreen() {
  const openScreen = useTabsStore((s) => s.openScreen);
  const navigate = useNavigate();
  return useCallback(
    (
      node: Pick<
        UserScreenNode,
        'screenId' | 'caption' | 'objectId' | 'screenTypeName' | 'iconId' | 'iconName'
      >,
      params?: Record<string, unknown>,
      opts?: { focusExisting?: boolean },
    ) => {
      const tab = openScreen(node, params, opts);
      navigate(`/s/${node.screenId}?tab=${tab.tabId}`, { replace: true });
      return tab;
    },
    [openScreen, navigate],
  );
}
